import { I18n } from 'i18n-js'
import en from './locales/en'
import es from './locales/es'

const i18n = new I18n({ en, es }, { defaultLocale: 'en', enableFallback: true })

export default i18n
export const t = i18n.t.bind(i18n)
